module.exports = __webpack_public_path__ + "static/media/dsr_checklist_orange.b7f871c1.svg";